import { motion } from 'motion/react';
import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';
import { ChatInitiativeOptionIdType } from '../../../../options/ChatInitiative/types';

export const ChatInitiativeStyles = styled(OnboardingPage)`
  .chat-initiative-title {
    margin: 0 0 28px;
  }

  ion-content {
    &::part(scroll) {
      padding: 26px 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 0 0 48px;
    }
  }
`;

export const ChatInitiativeAnswersStyles = styled.div`
  margin: 28px 0 0;
  padding: 0 16px;
  display: flex;
  width: 100%;
  align-items: stretch;
  gap: 12px;
  justify-content: space-between;
`;

export const ChatInitiativeAnswerItemStyles = styled(motion.div)<{
  answer: ChatInitiativeOptionIdType;
  isSelected: boolean;
}>`
  display: flex;
  flex-grow: 1;
  padding: 20px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #765279;
  cursor: pointer;
  user-select: none;

  ${({ isSelected }) => isSelected && 'background: #FFC9FB;'}

  .answer-title {
    ${({ isSelected }) => isSelected && 'color: #171123;'}
  }

  .answer-description {
    border-radius: 24px 24px 24px 0px;
    background: linear-gradient(0deg, #602a65 0%, #852c8d 100%);
    padding: 8px 16px;
    margin: 8px 0 0;

    ${({ answer }) =>
      answer === 'yes' &&
      `
        border-radius: 24px 24px 24px 0px;
        background: linear-gradient(0deg, #602a65 0%, #852c8d 100%);
      `}

    ${({ answer }) =>
      answer === 'i_take_the_lead' &&
      `
        border-radius: 24px 24px 0px 24px;
        background: linear-gradient(0deg, #4A266D 0%, #60318D 100%);
  `}
  }
`;
